import { useEffect, useState } from "react";

// Matches Tailwind's `md` breakpoint boundary: phones/small screens are < 768px.
// Keep this in sync with the `md:` prefixes used for the desktop layout.
const MOBILE_QUERY = "(max-width: 767px)";

/**
 * True when the viewport is below Tailwind's `md` breakpoint. For the rare cases
 * that need JS branching (e.g. sizing the waveform, rendering mobile-only sheets)
 * rather than CSS `md:` utilities. Pure CSS responsiveness should be preferred.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
